import { CommonModule } from '@angular/common';
import { Component, EnvironmentInjector, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { environment } from 'src/environments/environment';
import { ApiService } from 'src/services/api.service';
import { MessageService } from 'src/services/message.service';

@Component({
  selector: 'app-survey-response',
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule],
  templateUrl: './survey-response.component.html',
  styleUrls: ['./survey-response.component.scss'],
})
export class SurveyResponseComponent implements OnInit {
  isValidSurvey = false;
  surveyId: string | null = null;
  surveyType: 'nps' | 'csat' = 'nps';
  outboundId: string;
  tenantId: string;
  userId: string;
  email: string = '';
  conversationId: string;
  hash: string;

  selectedScore: number | null = null;
  comment: string = '';
  isLoading = false;
  isSubmitted = false;
  title = `Let us know how we're doing`;

  public environment = environment;

  // NPS scores range from 0-10
  npsScores = Array.from({ length: 11 }, (_, i) => i);

  // CSAT scores are typically 1-5
  csatScores = Array.from({ length: 5 }, (_, i) => i + 1);

  // Emoji options for CSAT
  csatEmojis = ['😡', '😞', '😐', '🙂', '🤩'];

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private msgService: MessageService,
    public environmentInjector: EnvironmentInjector,
  ) {}

  ngOnInit() {
    this.surveyId = this.route.snapshot.queryParamMap.get('surveyId');
    this.surveyType = (this.route.snapshot.queryParamMap.get('surveyType') ?? 'csat') as 'nps' | 'csat';
    this.outboundId = this.route.snapshot.queryParamMap.get('outboundId');
    this.tenantId = this.route.snapshot.queryParamMap.get('tenantId');
    this.userId = this.route.snapshot.queryParamMap.get('userId');
    this.hash = this.route.snapshot.queryParamMap.get('hash');
    this.conversationId = this.route.snapshot.queryParamMap.get('conversationId');
    if (this.route.snapshot.queryParamMap.get('value')) {
      this.selectedScore = Number(this.route.snapshot.queryParamMap.get('value'));
    }

    this.isValidSurvey = !!this.surveyId && !!this.tenantId && !!this.hash;

    // Save survey as soon as possible
    if (this.isValidSurvey && this.selectedScore) {
      this.submitSurvey(true);
    }
  }

  async submitSurvey(submitSecretly?: boolean) {
    if (!submitSecretly) {
      this.isLoading = true;
    }
    try {
      await this.apiService.postPromise(`/surveys/${this.surveyId}/responses`, {
        value: this.selectedScore,
        comment: this.comment,
        outboundId: this.outboundId,
        tenantId: this.tenantId,
        userId: this.userId,
        email: this.email,
        hash: this.hash,
        conversationId: this.conversationId,
      });

      if (!submitSecretly) {
        this.isSubmitted = true;
      }
    } catch (error) {
      if (!submitSecretly) {
        this.msgService.showError(error);
      }
    } finally {
      this.isLoading = false;
    }
  }
}
